import React, { useEffect, useState } from "react";
import FlashpeImg from "../../assets/images/spalsh.png";
import { db } from "../../config/firebase_config";
import { ref, get } from "firebase/database";
import { LoadingSpinner } from "../../components/mini-components/mini-components";
import { useLocation } from "react-router-dom";
import "./review.css";
import { IoFastFood } from "react-icons/io5";
import { BiFoodMenu } from "react-icons/bi";
import { Rating } from 'react-simple-star-rating'


const ReviewPage = ({setReviewUploaded}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderID = queryParams.get("orderID");
  const [orderInfo, setOrderInfo] = useState(null);
  const [startSubmitReview, setstartSubmitReview] = useState(false);
  const [rateList, setRateList] = useState([]);
  const [orderRating, setorderRating ] = useState(4);


  let review = "";


  useEffect(() => {
    console.log("initiation ra mawaa...");
    const fetchData = async () => {
      const dbRestRef = ref(db, `ConfirmPayment/${orderID}`);
      const orderSnap = await get(dbRestRef);
      console.log("<--- orderSnap --->", orderSnap.val());
      if (orderSnap.exists()) {
        const data = orderSnap.val();
        console.log("<--- order comp data  --->", data);
        setOrderInfo(data);
        const itemsList = []; // Create a temporary array
        data.food.forEach(food => {
          if(itemsList.indexOf((item) => item.productId == food.productId) == -1 ){
            itemsList.push({  
              productId: food.productId , 
              rating: food.rating != null ? parseFloat(food.rating) :  4, 
            });
          }
        });
        console.log("review value" ,  data)
        // review = data.rateComments   || "";
        // setorderRating(data.rateValue != null ? parseFloat(data.rateValue)  : 4)
        setRateList(itemsList); 
        console.log("rate list initial : " , rateList)
        // console.log("order val : " , orderInfo.food[0].userPhone ,orderInfo.restaurantOwner )
        // console.log("rstID : " , orderInfo.restaurantId)
     
      }
    };
    fetchData();
  }, []);


  const RatingItem = ({ name, food , isOrderReview  }) => {
    
    // console.log("rating info : " ,review , orderRating ,  rateList , "food" , food)
    return (
      <div className="rating-box">
        <h3 className={`item-name ${ !isOrderReview && "item-name-small"  } `}>
          {isOrderReview ? <BiFoodMenu /> : <IoFastFood />}
          {name}
        </h3>
        <Rating 
         key={name}
          onClick={(val) => {
            if(isOrderReview){
              setorderRating(val);
            }else{
              const index = rateList.findIndex(item => item.productId === food.productId);
              if (index !== -1) {
                setRateList(prevRateList => {
                  const newRateList = [...prevRateList];
                  newRateList[index] = {
                    productId: food.productId , 
                    rating: val, 
                  };
                  return newRateList;
                });
              }
            }
          }} 
          initialValue={isOrderReview ? orderRating : rateList.find(item => item.productId === food.productId)?.rating } 
          allowFraction
          size={30}
          emptyColor="#a4a5a8"
        />

      </div>
    );
  };


  const updateRatingAndComments = async () => {

    try {
      console.log("started" ,orderID , orderRating );
      const body ={
        orderId : orderID,
        userId :orderInfo.food[0].userPhone,
        orderRating : orderRating,
        orderReview : review,
        itemsRating : rateList
      };
      console.log("info : " ,body)
      const fetchOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json' 
        },
        body: JSON.stringify(body),
      };
    await fetch("https://revieworder-jdoxig6lva-uc.a.run.app" , fetchOptions );
   
 

    } catch (e) {
      console.error(e);
      // Handle your error here
    }
  }

  const SubmitButton = () => {
    return (
      startSubmitReview ?
      <LoadingSpinner/> 
      :<button 
        className='submit-btn' 
        onClick={ async() => { 
          setstartSubmitReview(true);
          console.log(rateList);
          console.log(orderRating , review);
          await updateRatingAndComments();
          setReviewUploaded(true);

    }
    } >Submit Review
        </button>
    )

    }
    
    

  return (
    <>
      {!orderInfo ? (
        <LoadingSpinner />
      ) : (
        <>
          <img
            src={FlashpeImg}
            alt=""
            width={"120px"}
            height={"120px"}
            className="flashpeImg"
          />
          <h2 className="heading">Rate your order</h2>
          <p className="description">
            Hey there! Spice up your experience by rating your order. Your
            feedback fuels our service perfection! 🌟{" "}
          </p>
          <section className="order-container">
            {orderInfo.food.map((item, index) => {
              return (
                <RatingItem
                  key={index}
                  food={item}
                  name={item.productName}
                  isOrderReview={false}
                />
              );
            })}
            <div style={{margin : "30px"}}></div>
           <RatingItem
              name="Order Rating"
              isOrderReview={true}
            />
            <textarea
              placeholder="Enter your order review"
              className="review-input"
              defaultValue={review}
              rows={3}
              onChange={(val) => {
                val.preventDefault();
                review = val.currentTarget.value
                console.log(review);
              }}
            />
          </section>
          <SubmitButton/>
        </>
      )}
      
    </>
  );
};

export default ReviewPage;
